module.exports = __webpack_public_path__ + "img/member15.b52e0010.png";